














































import { Component, Inject, Prop, Vue } from 'vue-property-decorator'
import { Company } from '@/api/model/company'
import { WidgetAvatarStyle } from '@/api/types'

interface SelectOptions {
    label: string,
    value: number
}

@Component
export default class EditEmmaWidgetForm extends Vue {
    @Inject() readonly reloadCompany: () => Promise<void>

    @Prop({ required: true }) readonly company: Company

    get widgetAvatarStyles(): SelectOptions[] {
        return [
            {
                label: null,
                value: WidgetAvatarStyle.A,
            }, {
                label: null,
                value: WidgetAvatarStyle.B,
            }, {
                label: null,
                value: WidgetAvatarStyle.C,
            },
        ]
    }

    get widgetAvatarSvg(): string[] {
        return [
            'brunette-circle',
            'blond-circle',
            'sylvana-circle',
        ]
    }

    get avatarType(): string {
        const avatarType = ['brunette', 'blond', 'sylvana']

        return avatarType[this.company.widgetAvatarStyle]
    }
}
